import { render, staticRenderFns } from "./IncidentFilter.vue?vue&type=template&id=247ab6bc&scoped=true&"
import script from "./IncidentFilter.vue?vue&type=script&lang=js&"
export * from "./IncidentFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247ab6bc",
  null
  
)

export default component.exports